<section class="upgrade-promotion__sumamry">
    <div>
        <div class="upgrade-promotion__sumamry__upgrade">
            <div class="upgrade-promotion__sumamry__upgrade__info">
                <h4>{{ 'fe_details_upgrade_promotion_title' | translate }}</h4>
                <p>
                    {{ 'fe_details_upgrade_promotion_info_1' | translate }}
                    {{ vehicle?.name }}
                    {{ 'fe_details_upgrade_promotion_info_2' | translate }}
                    {{ vehicleUpgrade?.name }}
                    {{ 'fe_details_upgrade_promotion_info_4' | translate }}
                </p>
            </div>
            <div class="upgrade-promotion__upgrade___sumamry_picture">
                <picture>
                    <img
                        alt="img-automovil"
                        class="card__img"
                        [src]="vehicleUpgrade?.img"
                    />
                </picture>
            </div>
        </div>
    </div>
</section>
